import { api } from "./api";

const typeOf = (href = "") => (href.startsWith("tel:") ? "call" : href.startsWith("sms:") ? "text" : /wa\.me|whatsapp\.com/.test(href) ? "whatsapp" : null);

const visitorId = () => {
  let v = localStorage.getItem("sw_vid");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("sw_vid", v); }
  return v;
};

// Counts every WhatsApp / call / text link tap on public pages.
export const onContactClick = (e) => {
  const a = e.target.closest?.("a[href]");
  const type = a && typeOf(a.getAttribute("href"));
  if (!type) return;
  const place = (a.closest("[data-testid]")?.getAttribute("data-testid") || "").slice(0, 40);
  api.post("/track/contact", { type, place, page: window.location.pathname, vid: visitorId() }).catch(() => {});
};
